var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolAssetTracking01 = function SvgSolAssetTracking01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_asset_tracking-01_svg2__a",
    x1: 79.05,
    x2: 236.6,
    y1: 224.81,
    y2: 62.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_asset_tracking-01_svg2__a",
    id: "sol_asset_tracking-01_svg2__b",
    x1: 78.32,
    x2: 235.88,
    y1: 224.11,
    y2: 61.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_asset_tracking-01_svg2__a",
    id: "sol_asset_tracking-01_svg2__c",
    x1: -32.1,
    x2: 125.45,
    y1: 117.14,
    y2: -45.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_asset_tracking-01_svg2__a",
    id: "sol_asset_tracking-01_svg2__d",
    x1: -32.82,
    x2: 124.73,
    y1: 116.44,
    y2: -46.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_asset_tracking-01_svg2__a",
    id: "sol_asset_tracking-01_svg2__e",
    x1: 50.72,
    x2: 208.28,
    y1: 197.38,
    y2: 34.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_asset_tracking-01_svg2__a",
    id: "sol_asset_tracking-01_svg2__f",
    x1: 23.26,
    x2: 180.81,
    y1: 170.77,
    y2: 8.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_asset_tracking-01_svg2__a",
    id: "sol_asset_tracking-01_svg2__g",
    x1: 47.35,
    x2: 204.91,
    y1: 194.11,
    y2: 31.48
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M159.28 100c-22.47.02-40.69 18.24-40.71 40.71 0 21.8 36.69 56.83 38.26 58.31a3.56 3.56 0 0 0 4.91 0c1.56-1.48 38.26-36.51 38.26-58.31-.03-22.48-18.24-40.69-40.72-40.71m0 91.45c-11.25-11.18-33.57-36.32-33.57-50.74 0-18.54 15.04-33.57 33.58-33.56 18.54 0 33.56 15.03 33.56 33.56 0 14.41-22.32 39.56-33.57 50.74",
    style: {
      fill: "url(#sol_asset_tracking-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28 119.11c-11.83 0-21.43 9.59-21.43 21.43s9.59 21.43 21.43 21.43 21.43-9.59 21.43-21.43c-.01-11.83-9.6-21.42-21.43-21.43m0 35.72c-7.89 0-14.29-6.4-14.29-14.29s6.4-14.29 14.29-14.29 14.29 6.4 14.29 14.29-6.4 14.28-14.29 14.29",
    style: {
      fill: "url(#sol_asset_tracking-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.26 99.02a3.56 3.56 0 0 0 4.91 0c1.56-1.48 38.26-36.51 38.26-58.31C81.42 18.23 63.19 0 40.71 0S0 18.23 0 40.71c0 21.8 36.7 56.83 38.26 58.31m2.46-91.88c18.53.02 33.55 15.04 33.57 33.57 0 14.41-22.32 39.56-33.57 50.74C29.46 80.27 7.14 55.12 7.14 40.71 7.16 22.18 22.18 7.16 40.71 7.14Z",
    style: {
      fill: "url(#sol_asset_tracking-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.14 40.54c0-11.83-9.59-21.43-21.43-21.43-11.83 0-21.43 9.59-21.43 21.43 0 11.83 9.59 21.43 21.43 21.43 11.83-.01 21.42-9.6 21.43-21.43m-35.71 0c0-7.89 6.4-14.29 14.29-14.29s14.29 6.4 14.29 14.29-6.4 14.29-14.29 14.29-14.28-6.4-14.29-14.29",
    style: {
      fill: "url(#sol_asset_tracking-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.86 192.86H41.07c-12.82 0-23.21-10.39-23.21-23.21s10.39-23.21 23.21-23.21h35.71c14.79 0 26.79-11.99 26.79-26.79S91.58 92.86 76.78 92.86H57.29c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57h19.49c10.85 0 19.64 8.79 19.64 19.64s-8.79 19.64-19.64 19.64H41.07c-16.77 0-30.36 13.59-30.36 30.36S24.3 200 41.07 200h101.79c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57",
    style: {
      fill: "url(#sol_asset_tracking-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28 60.71c5.91 0 10.71-4.8 10.71-10.71V10.71C170 4.8 165.2 0 159.28 0s-10.71 4.8-10.71 10.71V50c0 5.91 4.8 10.71 10.71 10.71m-3.57-50c0-1.97 1.6-3.57 3.57-3.57s3.57 1.6 3.57 3.57V50c0 1.97-1.6 3.57-3.57 3.57s-3.57-1.6-3.57-3.57z",
    style: {
      fill: "url(#sol_asset_tracking-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28 89.29c5.92 0 10.71-4.8 10.71-10.71s-4.8-10.71-10.71-10.71-10.71 4.8-10.71 10.71 4.8 10.71 10.71 10.71m0-14.29c1.97 0 3.57 1.6 3.57 3.57s-1.6 3.57-3.57 3.57-3.57-1.6-3.57-3.57 1.6-3.57 3.57-3.57",
    style: {
      fill: "url(#sol_asset_tracking-01_svg2__g)"
    }
  }));
};
export default SvgSolAssetTracking01;